import { render, staticRenderFns } from "./ticketsetting.vue?vue&type=template&id=6b934d6a&scoped=true"
import script from "./ticketsetting.vue?vue&type=script&lang=js"
export * from "./ticketsetting.vue?vue&type=script&lang=js"
import style0 from "./ticketsetting.vue?vue&type=style&index=0&id=6b934d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b934d6a",
  null
  
)

export default component.exports